import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { IsActive } from 'components/Chip'
import { containersMessages } from 'features/Snacks/components/Containers/messages'
import { safeFormatMessage } from 'utils/intl'

const NoWrap = styled.div<TSFixMe>`
  white-space: nowrap;
`

const Secondary = styled.div<TSFixMe>`
  font-size: 13px;
  color: #9999bd;
`

export const ItemsList = ({ items = [] }): TSFixMe => {
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
            </Th>

            <Th>
              <FormattedMessage id="dictionary.status" defaultMessage="Status" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.container" defaultMessage="Envase" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.category" defaultMessage="Categoría" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.refrigeration" defaultMessage="Refrigeración" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.stock" defaultMessage="Stock" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.sold" defaultMessage="Vendido" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.items.lost.label" defaultMessage="Merma" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {items.map((item: TSFixMe): TSFixMe => {
            return (
              <Tr key={item.id}>
                <Td>
                  <NoWrap>{item.name}</NoWrap>
                </Td>

                <Td>
                  <IsActive isActive={item.isActive} />
                </Td>

                <Td>
                  <FormattedMessage
                    id="spanish.items.list.container.value"
                    defaultMessage="{container} de {netContent}"
                    values={{
                      container: safeFormatMessage({ intl, messages: containersMessages, key: item.container }),
                      netContent: (
                        <>
                          <FormattedNumber value={item.netContent} /> {item.units}
                        </>
                      )
                    }}
                  />
                </Td>

                <Td>
                  <div>{item.category}</div>

                  {item.subcategory && <Secondary>{item.subcategory}</Secondary>}
                </Td>

                <Td>
                  {item.needsRefrigeration ? (
                    <FormattedMessage id="spanish.dictionary.yes" defaultMessage="Si" />
                  ) : (
                    <FormattedMessage id="spanish.dictionary.no" defaultMessage="No" />
                  )}
                </Td>

                <Td>
                  <FormattedNumber value={item.stockQuantity} />
                </Td>

                <Td>
                  <FormattedNumber value={item.soldQuantity} />
                </Td>

                <Td>
                  <FormattedNumber value={item.lostQuantity} />
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
